<template>
    <div class="show_enter">
  <!--    <el-scrollbar class="enter-scroll">-->
        <div class="enter_index">
          <img src="../assets/img/daolan/d_biaoti.png" class="d_biaoti" alt="" />
          <div class="closemap" style="z-index: 9999" @click="closeMap"></div>
          <div class="enter_index_map">
            
            <!-- <span v-for="(e, i) in city_data" :key="i" @click="load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" :class="{
                now_map_index: e.scene_ct_name == scene_ct_name, map_span: true
              }">{{ e.name }}</span> -->
              <span :class="span_class[main_index]" v-for="(e, i) in span_data" :key="i" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span_df_tj_dk" v-for="(e, i) in dftj_data_dk" :key="i+'dk'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span111" v-for="(e, i) in dftj111" :key="i+'span111'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span_df_tj_dk2" v-for="(e, i) in dftj_data_dk2" :key="i+'dk2'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span222" v-for="(e, i) in dftj222" :key="i+'span222'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span_df_tj_shu" v-for="(e, i) in dftj_data_shu" :key="i+'shu'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span3" v-for="(e, i) in dftj3" :key="i+'span3'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span4" v-for="(e, i) in dftj4" :key="i+'span4'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span5" v-for="(e, i) in dftj5" :key="i+'span5'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span6" v-for="(e, i) in dftj6" :key="i+'span6'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
  
              <span v-if="main_index==3" class="span7" v-for="(e, i) in dftj7" :key="i+'span7'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
  
              <span v-if="main_index==3" class="span8" v-for="(e, i) in dftj8" :key="i+'span8'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
              <span v-if="main_index==3" class="span9" v-for="(e, i) in dftj9" :key="i+'span9'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>

              <span v-if="main_index==3" class="span10" v-for="(e, i) in dftj10" :key="i+'span10'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>

              <span v-if="main_index==4" class="span_zt_you" v-for="(e, i) in span_zt_you" :key="i+'span_zt_you'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>

              <span v-if="main_index==4" class="span_zt_eeds" v-for="(e, i) in span_zt_eeds" :key="i+'span_zt_eeds'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>

              <span v-if="main_index==1" class="span_df_hlj" v-for="(e, i) in span_df_hlj" :key="i+'span_df_hlj'" @click="tp(e);load_scene(e)"
              :style="{ left: e.left, top: e.top, padding: e.isThree ? `0 ${px2vw(6)}` : `0  ${px2vw(13)}` }" 
              >{{ e.name }}</span>
  
            <div class="map_xt" @mouseenter="main_index=0;span_data=xt_data" @click="load_scene({
              scene_ct_name: '0_1',
              scene_name: 'scene_0_1_1',
              left: '7.39rem',
              top: '1.84rem',
              src: './img/514/b_t.png',
              width: '0.95rem',
            })"/>
            
            <img src="../assets/img/daolan/daolan-enter.png" @click="load_scene({
              scene_ct_name: '0_1',
              scene_name: 'scene_0_1_1',
              left: '7.39rem',
              top: '1.84rem',
              src: './img/514/b_t.png',
              width: '0.95rem',
            })
            " class="enter_img" alt="" />
            <!-- <a href="https://www.cibexpo.org.cn/" target="_blank" class="pprgw"></a> -->
  
            <div :class="daolan_main[main_index]" >
            </div>
            <div  v-if="main_index==4" class="ppsj" @click="ppsj=true;main_index=5;span_data=[]"></div>
            <div v-if="ppsj && main_index==5" class="ppsj_bg">
              <div class="ppsj_close" @click="ppsj=false;main_index=4;span_data=zt_data"></div>
              <el-scrollbar class="ppsj_img_bg">
              <!-- <div class="ppsj_img_bg"> -->
                
                <!-- <div class="ppsj_img"></div> -->
                <div class="ppsj_img" v-for="(e, i) in ppsjI" :key="i+'ppsj'" :class="'ppsj_'+e"></div>
              
              <!-- </div> -->
            </el-scrollbar>
            </div>
            <div class="pinpai" @click="load_scene({
              isBlank: true,
              isLink: true,
              href:'https://www.cibexpo.org.cn/'
            })">
            </div>
            <div class="xiaofei" @click="load_scene({
              isBlank: true,
              isLink: true,
              href:'https://culture-travel.cctv.com/special/2024ppxf/index.shtml'
            })">
            </div>
            <div class="difang" 
            @mouseenter="df=false;gzw=false;main_index=1;span_data=df_data;qiye_level=false">
            </div>
            <div v-if="!qiye_level" class="qiye" @mouseenter="qiye_level=true">
            </div>
            <div v-if="qiye_level" class="qiye_level2">
              <div  :class="gzw?'gzw_white':'gzw'" 
              @mouseenter="gzw=true;df=false;main_index=2;span_data=gzw_data"></div>
              <div  :class="df?'df_white':'df'"
              @mouseenter="df=true;gzw=false;main_index=3;span_data=dftj_data"></div>
            </div>
            
          <div class="arrow" :class="`arrow_${main_index}`"></div>
  
          <div class="zhuanti" 
            @mouseenter="df=false;gzw=false;main_index=4;span_data=zt_data;qiye_level=false">
          </div>
          </div>
        </div>
  <!--    </el-scrollbar>-->
    </div>
  </template>
  <script>
  // let krpano = document.getElementById("krpanoSWFObject");
  // import { mapState, mapMutations } from "vuex";
  import { px2vw } from '../utils';
  import {
    open_music,
    close_music,
    play_music,
    init_music
  } from '@/utils/audio'
  import { mapMutations } from 'vuex';
  import { giveThumbsUp, cityInfo, gzwInfo, dfInfo } from "@/utils/tools.js"
  
  module.exports = {
    props: {
      sceneName: "",
      krpano: ""
    },
    computed: {
      // ...mapState('common', {
      //   mainIndex: state => state.mainIndex
      // }),
      scene_ct_name: function () {
        var nowSceneName = this.sceneName.split("_");
  
        var index = nowSceneName[1] + "_" + nowSceneName[2];
  
        return index;
      },
    },
    data: function () {
      return {
        ppsj:false,
        ppsjI:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
        qiye_level:false,
        gzw:false,
        df:false,
        main_index:0,
        daolan_main:['daolan_main','daolan_main_df','daolan_main_gzw','daolan_main_dftj','daolan_main_zt','daolan_main_ppsj'],
        span_class:['span_xt','span_df','span_gzw_tj','span_df_tj','span_zt'],
        span_data:[],
        xt_data: [
          {
            name: "序言",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(970),
            top: px2vw(268),
            
          },
          {
            name: "第一单元\n领航",
            bj_c: "#805BA9",
            scene_name: "scene_0_2_1",
            scene_ct_name: "1_1",
            left: px2vw(709),
            top: px2vw(210),
          },
          {
            name: "第二单元\n部门建品牌",
            bj_c: "#805BA9",
            scene_name: "scene_0_3_1",
            scene_ct_name: "1_1",
            left: px2vw(710),
            top: px2vw(336),
          },
          {
            name: "第三单元\n地方育品牌",
            bj_c: "#805BA9",
            scene_name: "scene_0_4_1",
            scene_ct_name: "1_1",
            left: px2vw(710),
            top: px2vw(458),
          },
          {
            name: "第四单元\n媒体推品牌",
            bj_c: "#805BA9",
            scene_name: "scene_0_5_1",
            scene_ct_name: "1_1",
            left: px2vw(969),
            top: px2vw(384),
          },
          {
            name: "第五单元\n我们和品牌",
            bj_c: "#805BA9",
            scene_name: "scene_0_6_1",
            scene_ct_name: "1_1",
            left: px2vw(1234),
            top: px2vw(210),
          },
          {
            name: "第六单元\n创意与品牌",
            bj_c: "#805BA9",
            scene_name: "scene_0_7_1",
            scene_ct_name: "1_1",
            left: px2vw(1233),
            top: px2vw(336),
          },
          {
            name: "第七单元\n世界看品牌",
            bj_c: "#805BA9",
            scene_name: "scene_0_8_1",
            scene_ct_name: "1_1",
            left: px2vw(1234),
            top: px2vw(457),
          }
        ],
        df_data: [
        //是第一行
        {
            name: "北京",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(586),
            top: px2vw(258),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690877687013376'

        },
        // {
        //     name: "2",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_0_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(808),
        //     top: px2vw(259),
        // },
        {
            name: "西藏",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1250),
            top: px2vw(259),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690882099421184'
        },
        {
            name: "宁波",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1472),
            top: px2vw(259),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690883877806080'
        },
        {
            name: "山西",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(696),
            top: px2vw(292),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878341324800'
        },
        {
            name: "江西",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(918),
            top: px2vw(293),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880052600832'
        },
        {
            name: "湖南",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1028),
            top: px2vw(278),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880732078080'
        },
        {
            name: "重庆",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1139),
            top: px2vw(293),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881445109760'
        },
        {
            name: "新疆",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1361),
            top: px2vw(292),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690883223494656'
        },
        //第二行
        //
        {
            name: "天津",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(586),
            top: px2vw(321),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690877972226048'
        },
        {
            name: "上海",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(807),
            top: px2vw(320),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879180185600'
        },
        {
            name: "陕西",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1250),
            top: px2vw(321),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690882267193344'
        },
        {
            name: "大连",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1472),
            top: px2vw(321),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690883391266816'
        },
        // {
        //     name: "14",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_0_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(698),
        //     top: px2vw(354),
        // },
        {
            name: "山东",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(918),
            top: px2vw(356),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880211984384'
        },
        {
            name: "广东",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1028),
            top: px2vw(339),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880899850240'
        },
        {
            name: "四川",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1139),
            top: px2vw(355),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881587716096'
        },
        {
            name: "兵团",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1361),
            top: px2vw(354),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2690761190975479808'
        },
        //第三行
        //
        {
            name: "河北",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(586),
            top: px2vw(384),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878156775424'
        },
        {
            name: "江苏",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(807),
            top: px2vw(382),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879356346368'
        },
        {
            name: "甘肃",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1250),
            top: px2vw(383),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690882602737664'
        },
        {
            name: "厦门",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1472),
            top: px2vw(384),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690884053966848'
        },
        {
            name: "辽宁",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(696),
            top: px2vw(416),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878668480512'
        },
        {
            name: "河南",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(918),
            top: px2vw(419),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880371367936'
        },
        {
            name: "广西",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1028),
            top: px2vw(402),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881050845184'
        },
        {
            name: "贵州",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1139),
            top: px2vw(419),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881755488256'
        },
        {
            name: "深圳",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1361),
            top: px2vw(417),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690884255293440'
        },
        //第四行
        //
        {
            name: "浙江",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(807),
            top: px2vw(444),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879532507136'
        },
        {
            name: "青海",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1250),
            top: px2vw(445),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690882443354112'
        },
        {
            name: "吉林",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(696),
            top: px2vw(479),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878853029888'
        },
        {
            name: "湖北",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(918),
            top: px2vw(480),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880564305920'
        },
        {
            name: "云南",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1139),
            top: px2vw(480),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881931649024'
        },
        {
            name: "青岛",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1361),
            top: px2vw(478),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690883575816192'
        },
        //第五行
        //
        {
            name: "安徽",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(807),
            top: px2vw(507),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879708667904'
        },
        {
            name: "宁夏",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1250),
            top: px2vw(507),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2690774000447004672'
        },
        //最上面两个
        {
            name: "福建",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(918),
            top: px2vw(232),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879876440064'
        },
        {
            name: "海南",
            bj_c: "#805BA9",
            scene_name: "scene_0_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1139),
            top: px2vw(232),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881277337600'
        }
        ],
        gzw_data: [
          //第一行
          {
            name: "中核集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(607),
            top: px2vw(196),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692423447420928'
          },
          {
            name: "中国三峡\n集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(820),
            top: px2vw(196),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425368412160'
          },
          {
            name: "中国旅游\n集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1244),
            top: px2vw(196),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692429772431360'
          },
          {
            name: "中国航信",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1456),
            top: px2vw(196),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692432750387200'
          },
          //第二行
          {
            name: "航天科技",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(607),
            top: px2vw(250),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692423631970304'
          },
          {
            name: "国家电网",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(713),
            top: px2vw(250),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2687714133700255744'
          },
          {
            name: "国家能源\n集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(820),
            top: px2vw(250),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425561350144'
          },
          {
            name: "东风公司",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(925),
            top: px2vw(250),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692426727366656'
          },
          {
            name: "南航集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1137),
            top: px2vw(250),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428161818624'
          },
          {
            name: "中国商飞",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1244),
            top: px2vw(250),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692429982146560'
        
          },
          {
            name: "中国中铁",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1350),
            top: px2vw(250),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692431617925120'
          },
          {
            name: "中国航油",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1456),
            top: px2vw(250),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692432934936576'
          },
          //第三行
          {
            name: "航空工业\n集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(607),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692423816519680'
          },
          {
            name: "南方电网",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(713),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424764432384'
          },
          {
            name: "中国电信",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(820),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425754288128'
          },
          {
            name: "中国一重",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(926),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692426937081856'
          },
          {
            name: "中国五矿",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1137),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428572860416'
          },
          {
            name: "中煤集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1244),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692430368022528'
          },
          {
            name: "中国铁建",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1350),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692431810863104'
          },
          {
            name: "中国电建",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1456),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692433111097344'
          },
          //第四行
          {
            name: "中国航发",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(607),
            top: px2vw(359),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2693337520556482560'
          },
          {
            name: "中国华能",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(713),
            top: px2vw(361),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2687214108171837440'
          },
          {
            name: "中国联通",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(820),
            top: px2vw(361),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425947226112'
          },
          {
            name: "国机集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(925),
            top: px2vw(361),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427130019840'
          },
          {
            name: "通用技术\n集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1137),
            top: px2vw(361),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428757409792'
          },
          {
            name: "中国煤炭\n科工",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1244),
            top: px2vw(360),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692430577737728'
          },
          {
            name: "中交集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1350),
            top: px2vw(360),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692431987023872'
          },
          {
            name: "中广核",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1456),
            top: px2vw(360),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692433664745472'
          },
          //第五行
          {
            name: "中国石油",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(607),
            top: px2vw(414),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424185618432'
          },
          {
            name: "中国华电",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(713),
            top: px2vw(414),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424957370368'
          },
          {
            name: "中国移动",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(820),
            top: px2vw(414),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692426140164096'
          },
          {
            name: "东方电气\n集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(926),
            top: px2vw(414),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427339735040'
          },
          {
            name: "中国建筑",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1137),
            top: px2vw(414),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428933570560'
          },
          {
            name: "中国建材\n集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1244),
            top: px2vw(414),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2693692384562126848'
          },
          {
            name: "保利集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1350),
            top: px2vw(414),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692432372899840'
          },
          {
            name: "中国电气\n装备",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1456),
            top: px2vw(415),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692433866072064'
          },
          //第六行
          {
            name: "中国石化",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(607),
            top: px2vw(472),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424395333632'
          },
          {
            name: "国家电投",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(713),
            top: px2vw(469),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425158696960'
          },
          {
            name: "中国电子",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(819),
            top: px2vw(469),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2690727242773831680'
          },
          {
            name: "鞍钢",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(926),
            top: px2vw(469),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427549450240'
          },
          {
            name: "中国南水\n北调",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1137),
            top: px2vw(469),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692429344612352'
          },
          {
            name: "中国有色",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1243),
            top: px2vw(469),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2687714135470252032'
          },
          {
            name: "中煤地质\n总局",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1349),
            top: px2vw(469),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692432565837824'
          },
          {
            name: "中国绿发",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1456),
            top: px2vw(470),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692434050621440'
          },
          //第七行
          {
            name: "中国海油",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(607),
            top: px2vw(527),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424588271616'
          },
          {
            name: "中国一汽",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(819),
            top: px2vw(524),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2693338618264559616'
          },
          {
            name: "中国中车\n集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1244),
            top: px2vw(524),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692431164940288'
          },
          {
            name: "中国铁塔",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1456),
            top: px2vw(525),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692434243559424'
          },
          //中间四个
          {
            name: "中国东航",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1031),
            top: px2vw(448),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428354756608'
          },
          {
            name: "中航集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1031),
            top: px2vw(393),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427985657856'
          },
          {
            name: "中国远洋",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1031),
            top: px2vw(339),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2687714134765608960'
          },
          {
            name: "中铝集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1031),
            top: px2vw(284),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427775942656'
          },
        ],
        dftj_data: [
        //dftj_111 52 26
        //第一列 小框
          {
            name: "小米",
            bj_c: "#805BA9",
            left: px2vw(578),
            top: px2vw(171),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692193582784512'
          },
          {
            name: "首钢",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(632),
            top: px2vw(171),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692193842831360'
          },
          {
            name: "燕京啤酒",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(632),
            top: px2vw(198),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2689762291246702592'
          },
          {
            name: "同仁堂",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(198),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692194035769344'
          },
          {
            name: "扫地王",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(337),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2694351838680981504'
          },
          {
            name: "天地伟业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(632),
            top: px2vw(337),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2694348594370060288'
          },
          {
            name: "天津纺织",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(364),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2694349893329231872'
          },
          {
            name: "医药集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(632),
            top: px2vw(364),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2694350909424541696'
          },
          {
            name: "渤化集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(392),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692196736901120'
          },
          {
            name: "友发钢管",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(632),
            top: px2vw(392),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2694352529289912320'
          },
          {
            name: "鹏飞集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(632),
            top: px2vw(532),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692198162964480'
          },
          {
            name: "山西文旅",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(532),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692197970026496'
          },
          //第二列小框
          {
            name: "蒙牛乳业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(759),
            top: px2vw(256),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692199974903808'
          },
        //   {
        //     name: "蒙牛乳业",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1340),
        //     top: px2vw(390),
        //   },
          {
            name: "双奇药业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(759),
            top: px2vw(283),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692200369168384'
          },
          {
            name: "伊利实业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(704),
            top: px2vw(283),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692200176230400'
          },
          
          {
            name: "恒星化学",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(704),
            top: px2vw(310),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692200562106368'
          },
          {
            name: "金力永磁",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(759),
            top: px2vw(310),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692201115754496'
          },
          {
            name: "农牧厅",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(704),
            top: px2vw(337),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2683311679395078144'
          },
          {
            name: "伊泰集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(759),
            top: px2vw(337),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692201325469696'
          },
          {
            name: "东方美谷",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(704),
            top: px2vw(504),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692201895895040'
          },
          {
            name: "上海电气",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(759),
            top: px2vw(504),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692202113998848'
          },
          {
            name: "豫园集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(704),
            top: px2vw(531),
            isLink: true,
            href:''
          },
          {
            name: "百联集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(759),
            top: px2vw(531),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2697629142827933696'
          },
        //   {
        //     name: "42211111111",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1759),
        //     top: px2vw(364),
        //   },
        //   {
        //     name: "422",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(759),
        //     top: px2vw(392),
        //   },
          //第三列小框
          {
            name: "中联重科",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1208),
            top: px2vw(169),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2687876985891332096'
          },
          {
            name: "酒鬼酒",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1260),
            top: px2vw(169),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2687872018090565632'
          },
          {
            name: "商汤科技",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(171),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2697627891482501120'
          },
          {
            name: "三枪集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(171),
            isLink: true,
            href:''
          },
          {
            name: "包头钢铁",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(704),
            top: px2vw(256),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692199589027840'
          },
          {
            name: "莱克电气",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(256),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692203489730560'
          },
          
          {
            name: "波司登",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(256),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2697283114836697088'
          },
          {
            name: "添可智能",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(283),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692203858829312'
          },
          
          {
            name: "江苏盐业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(283),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692203674279936'
          },
          {
            name: "神通阀门",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(310),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692204605415424'
          },
          
          {
            name: "恒辉安防",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(310),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692204219539456'
          },
          {
            name: "海太欧林",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(337),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692205645602816'
          },
          
          {
            name: "东吴服务",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(337),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692205184229376'
          },
          {
            name: "中天科技",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(364),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692206023090176'
          },
          
          {
            name: "精华制药",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(364),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692205838540800'
          },
          {
            name: "盐南文旅",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(391),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2686978791519035392'
          },
          
          {
            name: "大路航空",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(391),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2686976524573220864'
          },
          {
            name: "苏豪控股",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(418),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2689741991318659072'
          },
          {
            name: "海康威视",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(888),
            top: px2vw(531),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692206425743360'
          },
          
          {
            name: "上上电缆",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(418),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2686988624091684864'
          },
          {
            name: "零跑汽车",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(834),
            top: px2vw(531),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692206224416768'
          },
          

          //第四列 小框
        //   {
        //     name: "物产中大金石",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(975),
        //     top: px2vw(247),
        //   },
  
          {
            name: "海螺集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1013),
            top: px2vw(412),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692208111853568'
          },
          {
            name: "江淮汽车",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(960),
            top: px2vw(410),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692207876972544'
          },
          {
            name: "丰原生物",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1013),
            top: px2vw(439),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692208514506752'
          },
          {
            name: "奇瑞控股",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(959),
            top: px2vw(439),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692208313180160'
          },
          
        //   {
        //     name: "华晟新能源",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(959),
        //     top: px2vw(467),
        //     isLink: true,
        //     href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692208908771328'
        //   },
          //第五列 小框
        
          {
            name: "药都樟树",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1084),
            top: px2vw(275),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2681060503224066048'
          },
          {
            name: "江铃汽车",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1138),
            top: px2vw(275),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2682834615248363520'
          },
          {
            name: "金钟科技",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1084),
            top: px2vw(329),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2690018022734700544'
          },
          {
            name: "魏桥创业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1138),
            top: px2vw(329),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2690021674866188288'
          },
          {
            name: "西王食品",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1084),
            top: px2vw(357),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2690023154566307840'
          },
        //   {
        //     name: "腾森橡胶",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1100),
        //     top: px2vw(385),
        //   },
          {
            name: "临工机械",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1138),
            top: px2vw(357),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2690019142899081216'
          },
        //   {
        //     name: "轮胎",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1138),
        //     top: px2vw(385),
        //   },
          {
            name: "许昌智能",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1084),
            top: px2vw(441),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2688386109041287168'
          },
          {
            name: "万洋冶炼",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1084),
            top: px2vw(469),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2688381868105015296'
          },
          {
            name: "莱檬生物",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1138),
            top: px2vw(441),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2688404810176143360'
          },
          {
            name: "卫华集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1138),
            top: px2vw(469),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880371367936&cid=2688383943949950976'
          },
    
          //第六行 小框
          {
            name: "太力科技",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1207),
            top: px2vw(331),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692215384776704'
          },
        
          {
            name: "小熊电器",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1261),
            top: px2vw(331),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2688532398404018176'
          },
          {
            name: "五粮液",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1332),
            top: px2vw(225),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692218899603456'
          },
          {
            name: "剑南春",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1385),
            top: px2vw(225),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692219377754112'
          },
         
            {
            name: "甘肃药业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1334),
            top: px2vw(475),
            isLink: true,
              href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2695817188215889920'
          },
          {
            name: "金徽酒业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1387),
            top: px2vw(475),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2695824742803316736'
          },
          {
            name: "金川集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(448),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692221240025088'
          },
        
          {
            name: "酒泉钢铁",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1388),
            top: px2vw(447),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2687043906134089728'
        },
          {
            name: "优联产业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1207),
            top: px2vw(359),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2682819110508699648'
          },
          {
            name: "梧州茶厂",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1207),
            top: px2vw(415),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692217398042624'
          },
          {
            name: "广西汽车",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1260),
            top: px2vw(414),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692217607757824'
          },
          {
            name: "农垦投资",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1207),
            top: px2vw(470),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2693656640778936320'
          },
          {
            name: "舒香门第",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1260),
            top: px2vw(470),
            isLink: true,
            href:''
          },
          {
            name: "广汽传祺",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1261),
            top: px2vw(359),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2682589553205714944'
          },
        
       




        //   {
        //     name: "移民搬迁农商科技",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1355),
        //     top: px2vw(334),
        //   },
        //   {
        //     name: "移民搬迁农商科技",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1355),
        //     top: px2vw(334),
        //   },
 
     
        
         
         
          //第八列 小框
          
        //   {
        //     name: "222",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1513),
        //     top: px2vw(171),
        //   },
        //   {
        //     name: "222",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1458),
        //     top: px2vw(198),
        //   },
        //   {
        //     name: "222",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1513),
        //     top: px2vw(198),
        //   },
        
        //   {
        //     name: "222",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(1513),
        //     top: px2vw(308),
        //   },
        ],
        dftj111:[
        {
            name: "华阳集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(784),
            top: px2vw(170),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692198355902464'
          },
        ],
        dftj_data_dk:[
          //1
          {
            name: "中德产业园",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(226),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2689741441520902144'
          },
          {
            name: "桂发祥十八街麻花",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(281),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2694346641342734336'
          },
          {
            name: "葡藤文化传媒",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(450),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2697291681115414528'
          },
       
     
          {
            name: "丹东药业集团",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(705),
            top: px2vw(450),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692201518407680'
          },
          {
            name: "源泰德润钢管制造",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(309),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2694349160282333184'
          },
          {
            name: "新路达商业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(833),
            top: px2vw(197),
            isLink: true,
            href:''
          },
          {
            name: "旭阳新材料",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(705),
            top: px2vw(391),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692200746655744'
          },
          {
            name: "科拓微生态",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(705),
            top: px2vw(364),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692199790354432'
          },
          {
            name: "代州黄酒",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(578),
            top: px2vw(504),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2697305457415954432'
          },
          //2
    
     
   

          //3

          {
            name: "雷允上药业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(835),
            top: px2vw(445),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692204999680000'
          },
          {
            name: "丰尚农牧装备",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(835),
            top: px2vw(472),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692205452664832'
          },
          //4
          {
            name: "物产中大金石",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(959),
            top: px2vw(248),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692206627069952'
          },
          {
            name: "瑞浦兰钧能源",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(959),
            top: px2vw(274),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692206828396544'
          },
     
          {
            name: "天桂食品",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(959),
            top: px2vw(530),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692209898627072'
          },
          {
            name: "中国光谷",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1083),
            top: px2vw(530),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2693659951846400000'
          },
          {
            name: "腾森橡胶轮胎",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1085),
            top: px2vw(383),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2690022521654222848'
          },
          {
            name: "大成国有资产管理",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1085),
            top: px2vw(248),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2690015125779259392'
          },
          {
            name: "谭木匠工艺品",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1207),
            top: px2vw(530),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2688490648931147776'
          },
          //6

         
    
       
    
    
  
          //71
          {
            name: "美奢锐新材料",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(171),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692218362732544'
          },
          {
            name: "圭目机器人",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(196),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692218647945216'
          },

          {
            name: "西部矿业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(530),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692220828983296'
          },
          {
            name: "移民搬迁农商科技",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(333),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692219973345280'
          },
          //8
          {
            name: "一九四九农文旅",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1458),
            top: px2vw(240),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2695791800982970368'
            
          },
          {
            name: "晓多科技",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(252),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692219772018688'
          },
          {
            name: "泸州老窖",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(279),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692219184816128'
            
          },
          {
            name: "华录智达",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1460),
            top: px2vw(472),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2695818839572094976'
            
          },
          {
            name: "幸福健康产业",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1460),
            top: px2vw(357),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692226214469632'
          },
   
 

          {
            name: "金牌厨柜家居",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1458),
            top: px2vw(530),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692224847126528'
          },
        ],
        dftj_data_dk2:[
          //222
          {
            name: "杏花村汾酒",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(705),
            top: px2vw(172),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692198783721472'
          },
          {
            name: "广誉远中药",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(705),
            top: px2vw(198),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692199136043008'
          },

        //   {
        //     name: "海康威视",
        //     bj_c: "#805BA9",
        //     scene_name: "scene_1_1_1",
        //     scene_ct_name: "1_1",
        //     left: px2vw(880),
        //     top: px2vw(531),
        //     isLink: true,
        //     href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692206425743360'
        //   },
          //333
   
  
          //444
          
        

          //555
          // {
          //   name: "金川集团",
          //   bj_c: "#805BA9",
          //   scene_name: "scene_1_1_1",
          //   scene_ct_name: "1_1",
          //   left: px2vw(1325),
          //   top: px2vw(448),
          //   isLink: true,
          //   href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692193842831360'
          // },
          // {
          //   name: "甘肃药业",
          //   bj_c: "#805BA9",
          //   scene_name: "scene_1_1_1",
          //   scene_ct_name: "1_1",
          //   left: px2vw(1325),
          //   top: px2vw(475),
          //   isLink: true,
          //   href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692193842831360'
          // },
          // {
          //   name: "金徽酒业",
          //   bj_c: "#805BA9",
          //   scene_name: "scene_1_1_1",
          //   scene_ct_name: "1_1",
          //   left: px2vw(1380),
          //   top: px2vw(475),
          //   isLink: true,
          //   href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692193842831360'
          // },
          //666
       
        ],
        dftj3:[
        {
            name: "华晟新能源",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(960),
            top: px2vw(468),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692208908771328'
          },
        ],
        dftj4:[
        {
            name: "合力",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1026),
            top: px2vw(467),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2681219522978914304'
          },
        ],
        dftj5:[
        {
            name: "金维集成电路",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1208),
            top: px2vw(198),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2687876167960109056'
          },
          {
            name: "武陵源景区",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1208),
            top: px2vw(225),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2687875201072373760'
          },
        ],
        dftj6:[
        {
            name: "英博尔电气",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1208),
            top: px2vw(280),
            isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exibitionId=2674690886629269504&cid=2682619933967261696'
          },
          {
            name: "新宝堂陈皮",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1208),
            top: px2vw(305),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2688523835019370496'
          },
          {
            name: "创鑫激光",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1459),
            top: px2vw(330),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692225568546816'
          },
          {
            name: "兆威机电",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1460),
            top: px2vw(303),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692225182670848'
          },
          {
            name: "延长石油",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(364),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2690724454987735040'
          },
          {
            name: "陕西汽车",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1333),
            top: px2vw(391),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2681142740758044672'
          },
        ],
        dftj7:[ {
            name: "青岛啤酒",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1512),
            top: px2vw(415),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2681050674501787648'
          },
          {
            name: "青岛品牌",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1460),
            top: px2vw(415),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2697312776602263552'
          },],
          dftj8:[
{
            name: "宁夏葡萄酒",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1461),
            top: px2vw(173),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2690725954745016320'
          },
          ],
     dftj9:[{
            name: "浙江\n石油\n化工",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1037),
            top: px2vw(302),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692207231049728'
          },],
      dftj10:[
      {
            name: "岳阳\n林纸",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1287),
            top: px2vw(197),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2687872952162066432'
          },
      ],
        dftj222:[
            
        {
            name: "海港集团 ",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(960),
            top: px2vw(302),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2697655763756654592'
          },
          {
            name: "好淘供应链",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(960),
            top: px2vw(330),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692207667257344'
          },
          {
            name: "康恩贝制药",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(960),
            top: px2vw(359),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692207440764928'
          },
          
        ],
        dftj_data_shu:[
         
          // {
          //   name: "",
          //   bj_c: "#805BA9",
          //   scene_name: "scene_1_1_1",
          //   scene_ct_name: "1_1",
          //   left: px2vw(1530),
          //   top: px2vw(300),
          // },
          // {
          //   name: "岳阳\n林纸",
          //   bj_c: "#805BA9",
          //   scene_name: "scene_1_1_1",
          //   scene_ct_name: "1_1",
          //   left: px2vw(1280),
          //   top: px2vw(195),
          //   isLink: true,
          //   href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2687872952162066432'
          // }, 
          {
            name: "慕思\n健康\n睡眠",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1278),
            top: px2vw(280),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2688521448175181824'
          },
          
          {
            name: "西北\n有色\n金属",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1402),
            top: px2vw(364),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692220451495936'
          },
          {
            name: "比\n亚\n迪",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(1529),
            top: px2vw(303),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886629269504&cid=2674692225862148096'
          },
        ],
        span_df_hlj:[
          {
            name: "黑龙江",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(696),
            top: px2vw(354),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879004024832'
          },
          {
            name: "内蒙古",
            bj_c: "#805BA9",
            scene_name: "scene_1_1_1",
            scene_ct_name: "1_1",
            left: px2vw(807),
            top: px2vw(259),
            isLink: true,
            href:'https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878500708352'
          },
        ],
        zt_data: [
        //zuo1
        // {
        //   name: "鄂尔多斯",
        //   bj_c: "#805BA9",
        //   scene_name: "scene_1_1_1",
        //   scene_ct_name: "1_1",
        //   left: px2vw(661),top: px2vw(332),
        //   left: px2vw(764),top: px2vw(393),
        // },
        {
          name: "延边",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(764),
          top: px2vw(332),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885194817536'
        },
        {
          name: "苏州",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(867),
          top: px2vw(332),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690884616003584'
        },
        //2
        {
          name: "景德镇",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(764),
          top: px2vw(393),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885362589696'
        },
        //3
        {
          name: "中山",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(661),
          top: px2vw(454),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885010268160'
        },
        {
          name: "眉山",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(764),
          top: px2vw(454),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690884800552960'
        },
        {
          name: "榆林",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(867),
          top: px2vw(454),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885530361856'
        },
      ],
      span_zt_eeds:[
      {
        name: "鄂尔多斯",
        bj_c: "#805BA9",
        scene_name: "scene_1_1_1",
        scene_ct_name: "1_1",
        left: px2vw(660),
        top: px2vw(332),
        isLink: true,
        href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885689745408'
      }
      ],
      span_zt_you:[
      {
          name: "施工企业管理协会",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(1235),
          top: px2vw(334),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2687744855517437952'
      },
      {
          name: "自行车协会",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(1235),
          top: px2vw(404),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2687744855542603776'
      },
      {
          name: "注册会计师协会",
          bj_c: "#805BA9",
          scene_name: "scene_1_1_1",
          scene_ct_name: "1_1",
          left: px2vw(1235),
          top: px2vw(474),
          isLink: true,
          href:'https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2687744855567769600'
      },
      ]
      };
    },
  
    components: {},
    
    mounted: function () {
      this.span_data=this.xt_data;
      // let startscene = this.$route.query.startscene
      // if (startscene=='scene_0_1_1') {
      //   this.$nextTick(()=>{
      //     this.krpano.call(
      //       "loadscene(" +
      //       "scene_0_1_1" +
      //       ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      //     );
      //     this.$emit("closeEnter");
      //   })
      // }
    },
    watch: {
  
  
    },
    methods: {
      ...mapMutations('common', ['SET_TP']),
      // ...mapMutations('common', ['SET_MAIN_INDEX']),
      px2vw(num) {
        return px2vw(num)
      },
      replaceNew(str, replacement) {
        return str.replace(/\r?\n/g, replacement);
      },
      tp(item){
        try {
          let name = this.replaceNew(item.name, "");
          if(this.main_index==1){
            let city = cityInfo.filter(i => i.name == name)[0]
            giveThumbsUp(16020, city.groupId, city.id)
          }else if(this.main_index==2){
            let gzw = gzwInfo.filter(i => i.name == name)[0]
            giveThumbsUp(16020, gzw.groupId, gzw.id)
          }else if(this.main_index==3){
            let df = dfInfo.filter(i => i.name == name)[0]
            giveThumbsUp(16020, df.groupId, df.id)
          }
        } catch (error) {
        }
      },
      load_scene: function (e) {
        /* 点击传递埋码 */
        window.goldlog.record("/spec.1.1", "", "snsScene=导览页&product=pcweb&pagename=云上2024年品博会", "");
  
        if (e.isLink) {
          if(e.isBlank){
            window.open(e.href)
          }else{
            window.open(e.href,'_self')
          }
          return
        }
        if (e.disableClick) {
          if (e.handleEmit) {
            this.$emit(e.handleEmit)
            this['SET_TP'](false);
            this.closeMap()
          } else {
  
          }
          return
  
        }
        
        this.krpano.call(
          "loadscene(" +
          e.scene_name +
          ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
        );
        this['SET_TP'](false);
        this.closeMap()
      },
  
      closeMap() {
        // this['SET_MAIN_INDEX'](this.main_index);
        if (sessionStorage.bgmusic == "play") {
          init_music();
        }
        this.$emit("closeEnter")
      },
    },
  };
  </script>
  <style scoped lang="scss">
  .d_biaoti {
    position: absolute;
    left: 50%;
    top: 90px;
    width: 1140.3px;
    height: 63.9px;
    transform: translate(-50%, 0);
  }
  
  .enter_img {
    position: absolute;
    top: 105px;
    left: 0;
    width: 148.2px;
    height: 96.6px;
    margin-left: -28px;
    cursor: pointer;
    z-index: 99;
    animation: enter_img 1.5s infinite;
    -moz-animation: enter_img 1.5s infinite;
    /* Firefox */
    -webkit-animation: enter_img 1.5s infinite;
    /* Safari 和 Chrome */
    -o-animation: enter_img 1.5s infinite;
    /* Opera */
  }
  
  @keyframes enter_img {
    0% {
      left: 0px;
    }
  
    50% {
      left: 35px
    }
  
    100% {
      left: 0px;
    }
  }
  
  
  
  .now_icon_map {
    position: absolute;
    transform: scale(0.4);
  }
  
  .show_enter {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 100000;
    top: 0;
    left: 0;
  }
  
    .enter_index {
      width: 100%;
      height: 100%;
      background-image: url("../assets/img/daolan/daolanbg.jpg");
  
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center;
    position: relative;
  }
  
  .closemap {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 55px;
    height: 55px;
    background: url("../assets/img/map/map-close-icon.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
  
  .closemap:hover {
    transform: rotate(180deg);
  }
  
  .enter_index_map {
    width: 1597px;
    height: 761px;
    // background-image: url(../assets/img/daolan/map-bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    transform: translate(-50%, 0);
    top: 160px;
    left: 50%;
  }
  
  .map_xt {
    position: absolute;
    background-size: 100% 100%;
    background-image: url("../assets/img/daolan/daolan-xt.png");
    background-repeat: no-repeat;
    width: 250px;
    height: 250px;
    cursor: pointer;
    left: 160px;
    top: 30px;
    //animation: rotate 1s linear infinite;
    // -moz-animation: enter_img 1.5s linear infinite;
    // -webkit-animation: enter_img 1.5s linear infinite;
    // -o-animation: enter_img 1.5s linear infinite;
  }
  .xt_circle {
    position: absolute;
    background-size: 100% 100%;
    background-image: url("../assets/img/daolan/xt_cricle.png");
    background-repeat: no-repeat;
    width: 250px;
    height: 250px;
    cursor: pointer;
    left: 160px;
    top: 30px;
    animation: rotate 1s linear infinite;
    -moz-animation: rotate 1s linear infinite;
    -webkit-animation: rotate 1s linear infinite;
    -o-animation: rotate 1s linear infinite;
  }
  
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  
  .xt-item {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    height: 35px;
    text-align: left;
    margin-bottom: 2px;
  
    .xt-item-label {
      display: inline-block;
      width: 78px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      cursor: pointer;
    }
  
    .xt-item-title {
      margin-left: 10px;
      display: inline-block;
    }
  
    &.xt_active {
  
      .xt-item-title,
      .xt-item-label {
        color: #f1211c;
      }
    }
  
    &:nth-child(2n+1) {
      .xt-item-label {
        background-color: #f3b4a7;
        border-radius: 5px;
        text-align: center;
  
      }
    }
  }
  
  .enter_index_map_xt {
    /* background-image: url(../img/map_list/big_map_xt.png); */
  }
  
  .map_xt:hover {
    /* background-image: url(../img/map_list/big_map_xt.png); */
  }
  
  .enter_index_map span{
    position: absolute;
    color: #fff;
    line-height: 1.4;
    box-sizing: border-box;
    cursor: pointer;
    //border-radius: 3px;
  
    /* padding: 0.04rem 0.1rem; */
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 12px;
  
    z-index: 100010;
    letter-spacing:7px;
    font-weight: bold;
    white-space: pre-line;
  
    // background-color: #000 !important;
    // opacity: 0.3;
  
    &.jqqd {
      left: 1259px;
      top: 533px;
      padding: 0 13px;
    }
  }
  .span_xt{
    width: 194px;
    height: 69px;
    font-size: 20px;
    padding-left: 18px !important;
    // letter-spacing:3px !important;
  }
  .span_df{
    width: 78px;
    height: 42px;
    font-size: 17px;
    letter-spacing:0px !important;
  }
  .span_gzw_tj{
    width: 76px;
    height: 42px;
    font-size: 14px;
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  
  .span_df_tj{
    width: 52px;
    height: 26px;
    font-size: 12px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span111{
    width: 27px;
    height: 53px;
    font-size: 10px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span_df_tj_dk{
    width: 106px !important;
    height: 26px;
    font-size: 12px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span_df_tj_dk2{
    width: 76px;
    height: 24px;
    font-size: 10px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span222{
    width: 73px;
    height: 24px;
    font-size: 12px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span3{
    width: 64px;
    height: 23px;
    font-size: 12px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span4{
    width: 39px;
    height: 26px;
    font-size: 10px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span5{
    width: 76px;
    height: 23px;
    font-size: 12px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span6{
    width: 66px;
    height: 23px;
    font-size: 12px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  
  }
  .span7{
    width: 50px;
    height: 20px;
    font-size: 12px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span8{
    width: 103px;
    height: 35px;
    font-size: 12px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span9{
    width: 28px;
    height: 80px;
    font-size: 10px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span10{
    width: 26px;
    height: 52px;
    font-size: 10px;   
    letter-spacing:0px !important;
    padding: 0px !important;
  }
    .span_df_tj_shu{
    width: 35px;
    height: 50px;
    font-size: 11px;
    letter-spacing:0px !important;
    padding: 0px !important;
  }
  .span_df_tj_nx{
    width: 106px;
    height: 39px;
    font-size: 11px;
    letter-spacing:0px !important;
  }
  .span_df_tj_s{
    width: 25px;
    height: 81px;
    font-size: 10px;
    letter-spacing:0px !important;
  }
  
  .span_zt{
    width: 76px;
    height: 42px;
    font-size: 17px;
    padding-right: 0 !important;
    padding-left: 2px !important;
    letter-spacing: 5px !important;
  }
  //文字
  .span_df_hlj{
    width: 78px;
    height: 42px;
    font-size: 17px;
    letter-spacing:0px !important;
  }
  .span_zt_you{
    font-size: 20px;
    width: 215px;
    height: 46px;
    padding-right: 0 !important;
    letter-spacing:3px !important;
    padding-left: 5px !important;
  }
  .span_zt_zckj{
    font-size: 15px;
    width: 164px;
    height: 46px;
    letter-spacing:3px !important;
    padding-left: 19px !important;
  }
  .span_zt_eeds{
    font-size: 17px;
    width: 76px;
    height: 42px;
    padding-right: 0 !important;
    letter-spacing:0 !important;
    padding-left: 0 !important;
  }
  .span_zt_jdz{
    font-size: 17px;
    width: 76px;
    height: 42px;
    letter-spacing:0px !important;
  }
  
  .enter_index_map span:nth-child(76) {
  
    width: 80px;
    padding: 0;
  }
  
  .enter_index_map span:hover {
    background: #f1211c;
    //background-color: #fff;
    //opacity: 0.3;
  }
  
  // .pprgw {
  //   display: block;
  //   width: 317px;
  //   height: 44px;
  //   background-image: url(../assets/img/daolan/web-enter.png);
  //   background-repeat: no-repeat;
  //   background-size: 100% 100%;
  //   position: absolute;
  //   right: 145px;
  //   bottom: 28px;
  //   animation: enter_web 1.5s infinite;
  // }
  
  @keyframes enter_web {
    0% {
      right: 145px;
    }
  
    50% {
      right: 125px
    }
  
    100% {
      right: 145px;
    }
  }
  
  // .now_map_index {
  //   background: #f1211c !important;
  // }
  
  .daolan_main, .daolan_main_df, .daolan_main_gzw, .daolan_main_dftj, .daolan_main_zt, .daolan_main_ppsj{
    width: 1152px;
    height: 550px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    transform: translate(-50%, 0);
    top: 80px;
    left: 1070px;
  }
  .daolan_main{
    background-image: url(../assets/img/daolan/map-bg.jpg);
  }
  .daolan_main_df{
    background-image: url(../assets/img/daolan/map-bg1.jpg);
  }
  .daolan_main_gzw{
    background-image: url(../assets/img/daolan/map-bg2.jpg);
  }
  .daolan_main_dftj{
    background-image: url(../assets/img/daolan/map-bg3.jpg);
  }
  .daolan_main_zt{
    background-image: url(../assets/img/daolan/map-bg4.jpg);
  }
  .daolan_main_ppsj{
    background-image: url(../assets/img/daolan/map-bg5.png);
  }
  
  .pinpai {
    width: 320.4px;
    height: 54.9px;
    background-image: url(../assets/img/daolan/pinpai.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    //transform: translate(-50%, 0);
    top: 687px;
    left: 614px;
    cursor: pointer;
    transform: scale(1);
  }
  .pinpai:hover {
    transform: scale(1.1);
  }
  .ppsj_close{
    width: 43px;
    height: 43px;
    float: right;
    cursor: pointer;
    border-radius: 45px;
  }
  .ppsj {
    width: 151px;
    height: 58px;
    background-image: url(../assets/img/daolan/ppsj.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    //transform: translate(-50%, 0);
    top: 533px;
    left: 993px;
    cursor: pointer;
  }
  .ppsj:hover {
    top: 530px;
    transform: scale(1.1);
  }
  .ppsj_bg{
    width: 960px;
    height: 425px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    transform: translate(-50%, 0);
    top: 137px;
    left: 1070px;
    background-image: url(../assets/img/daolan/ppsj_bg.jpg);
    //overflow: hidden;
    border-radius: 8px;
  }
  .ppsj_img{
    // width: 900px;
    width: 96%;
    // height: 1070px;
    height: 65px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // position: absolute;
    background-position: center;
    position: relative;
    // margin-left: 19px;
   // transform: translate(0, 8%);
    // background-image: url(../assets/img/daolan/ppsj_img.jpg);
    margin-left: 2%;
  }
  .ppsj_1{
    background-image: url(../assets/img/daolan/ppsj/01.png);
  }
  .ppsj_2{
    background-image: url(../assets/img/daolan/ppsj/02.png);
  }
  .ppsj_3{
    background-image: url(../assets/img/daolan/ppsj/03.png);
  }
  .ppsj_4{
    background-image: url(../assets/img/daolan/ppsj/04.png);
  }
  .ppsj_5{
    background-image: url(../assets/img/daolan/ppsj/05.png);
  }
  .ppsj_6{
    background-image: url(../assets/img/daolan/ppsj/06.png);
  } 
  .ppsj_7{
    background-image: url(../assets/img/daolan/ppsj/07.png);
  }
  .ppsj_8{
    background-image: url(../assets/img/daolan/ppsj/08.png);
  }
  .ppsj_9{
    background-image: url(../assets/img/daolan/ppsj/09.png);
  } 
  .ppsj_10{
    background-image: url(../assets/img/daolan/ppsj/10.png);
  }  
  .ppsj_11{
    background-image: url(../assets/img/daolan/ppsj/11.png);
  }
  .ppsj_12{
    background-image: url(../assets/img/daolan/ppsj/12.png);
  }
  .ppsj_13{
    background-image: url(../assets/img/daolan/ppsj/13.png);
  }
  .ppsj_14{
    background-image: url(../assets/img/daolan/ppsj/14.png);
  }
  .ppsj_15{
    background-image: url(../assets/img/daolan/ppsj/15.png);
  }

  .ppsj_16{
    background-image: url(../assets/img/daolan/ppsj/16.png);
  }  
  .ppsj_17{
    background-image: url(../assets/img/daolan/ppsj/17.png);
  }

  
  .ppsj_img_bg{
    width: 960px;
    height: 353px;
    position: absolute;
    transform: translate(0, 13%);
    // overflow: hidden;
    // overflow-y: auto;
    //overflow-x: hidden;
    margin-top: 12px;
    // padding: 0 2%;
  }
  
  .xiaofei {
    width: 426.6px;
    height: 54.9px;
    background-image: url(../assets/img/daolan/xiaofei.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    top: 687px;
    left: 1117px;
    cursor: pointer;
    transform: scale(1);
  }
  .xiaofei:hover {
    transform: scale(1.1);
  }
  
  .difang{
    width: 347px;
    height: 175px;
    background-image: url(../assets/img/daolan/difang.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    transform: translate(-50%, 0);
    top: 265px;
    left: 120px;
    cursor: pointer;
  }
  .difang:hover {
    opacity: 0.88; /* 设置透明度 */
  }
  .qiye, .qiye_level2{
    width: 330px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    transform: translate(-50%, 0);
    top: 424px;
    left: 240px;
    cursor: pointer;
  }
  
  .qiye{
    height: 179px;
    background-image: url(../assets/img/daolan/qiye.jpg);
  }
  
  .qiye_level2{
    height: 192px;
    background-image: url(../assets/img/daolan/qiye_level2.png);
  }
  .gzw, .gzw_white{
    width: 266px;
    height: 71px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-image: url(../assets/img/daolan/gzw.jpg);
    margin-left: 33px;
    margin-top: 23px;
  }
  .gzw_white{
    width: 260px;
    height: 65px;
    background-image: url(../assets/img/daolan/gzw-white.jpg);
    margin-left: 36px;
    margin-top: 25px;
    margin-bottom: 8px;
  }
  .gzw:hover{
    opacity: 0.88; /* 设置透明度 */
  }
  
  .df, .df_white{
    width: 265px;
    height: 69px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-image: url(../assets/img/daolan/df.jpg);
    margin-left: 33px;
    margin-top: 4px;
  }
  .df_white{
    width: 259px;
    height: 63px;
    background-image: url(../assets/img/daolan/df-white.jpg);
    margin-left: 36px;
    margin-top: 6px;
  }
  .df:hover{
    opacity: 0.88; /* 设置透明度 */
  }
  
  .zhuanti {
    width: 335px;
    height: 152px;
    background-image: url(../assets/img/daolan/zhuanti.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    transform: translate(-50%, 0);
    top: 620px;
    left: 150px;
    cursor: pointer;
  }
  .zhuanti:hover {
    opacity: 0.88; /* 设置透明度 */
  }
  .arrow, .arrow_1, .arrow_2, .arrow_3, .arrow_4, .arrow_5{
    width: 54px;
    height: 60px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    background-position: center;
    transform: translate(-50%, 0);
    background-image: url(../assets/img/daolan/arrow.png);
  }
  .arrow_0{
    top:127px;
    left:453px;
  }
  .arrow_1{
    top:318px;
    left:353px;
  }
  .arrow_2{
    top:452px;
    left:453px;
  }
  .arrow_3{
    top:522px;
    left:453px;
  }
  .arrow_4, .arrow_5{
    top:614px;
    left:393px;
    transform: scale(2);
    background-image: url(../assets/img/daolan/arrowC.png);
  }
  </style>
  <style lang="scss">
   
  .enter-scroll{
    width: 100%;
    height: 100%;
    .el-scrollbar__view{
      width: 100%;
      height: 100%;
    }
  }
  </style>
  <style lang="scss">
  .el-scrollbar {
    height: 100%;
  }
  
  .ppsj_bg{
  
    .el-scrollbar__bar {
        &.is-vertical {
          width: 0.25rem; //滚动条宽度
          background-color: #c7c7c7;
        }
      }
  
    .el-scrollbar__wrap {
        overflow-y: auto;
        overflow-x: hidden;
      }
  
    .el-scrollbar__thumb {
        ////可设置滚动条颜色
        background-image: url("../assets/img/scroll-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
  
  }
  
  </style>